import * as React from 'react';

import { Container, Content, BottomBar, Section } from '../../modules';
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';


class Dashboard extends React.Component<IAuthProps & RouteComponentProps<any>, {}> {
  constructor(props: IAuthProps & RouteComponentProps<any>) {
    super(props);
    this.state = {
      items: []
    }
  }

  componentDidMount() {
  } 

  render() {
    let p = this.props;
    return (
      <Container>
        <Content>
          <Section padded>
            This dashboard is currently empty.
          </Section>
        </Content>
        <BottomBar>
          <div>
          </div>
        </BottomBar>
      </Container>
    );
  }
}

export { Dashboard };
